export default function phoneMask(phone) {
  const cleanNoNumbersCharacters = phone.replace(/\D/g, '');

  if (cleanNoNumbersCharacters.length <= 2)
    return cleanNoNumbersCharacters.replace(/(\d{2})/, '+$1 ');

  if (cleanNoNumbersCharacters.length <= 4)
    return cleanNoNumbersCharacters.replace(/(\d{2})(\d{1,2})/, '+$1 $2');

  if (cleanNoNumbersCharacters.length <= 8)
    return cleanNoNumbersCharacters.replace(
      /(\d{2})(\d{2})(\d)/,
      '+$1 ($2) $3',
    );

  if (cleanNoNumbersCharacters.length <= 11)
    return cleanNoNumbersCharacters.replace(
      /(\d{2})(\d{2})(\d{4})(\d)/,
      '+$1 ($2) $3-$4',
    );

  return cleanNoNumbersCharacters
    .replace(/(\d{2})(\d{2})(\d{4,5})(\d{4})/, '+$1 ($2) $3-$4')
    .substring(0, 19);
}
